import React from 'react';
import Switch from 'react-switch';

export interface IAdminSwitch {
    value: boolean;
    onChange: (value: boolean) => void;
}

const AdminSwitch = ({ value, onChange }: IAdminSwitch) => {
    return (
        <Switch
            height={18 * 0.7}
            width={40 * 0.7}
            handleDiameter={22 * 0.7}
            onHandleColor={'#0B78C8'}
            offHandleColor={'#0B78C8'}
            onColor={'#BFDFF7'}
            offColor={'#dfdfdf'}
            checkedIcon={false}
            uncheckedIcon={false}
            checked={value}
            onChange={onChange}
        />
    );
};

export default AdminSwitch;
